module.exports = __webpack_public_path__ + "static/media/lungern-plazaA-04.9d113ec7.webp";